/* SlickMod guest Garage. Use the same code on the Garage page and before the menu script. */
(function () {
  'use strict';
  if (
    window.SlickModGarage &&
    window.SlickModGarage.createMenuBox
  ) return;

  var previousGarageRequest =
    window.SlickModGarage && window.SlickModGarage.request;
  var storageKey = 'slickmod-guest-garage-v1';
  var endpoint = '/apps/slickmod-garage';
  var queue = Promise.resolve();

  function key(vehicle) {
    return [vehicle.year, vehicle.make, vehicle.model].map(String).join('|');
  }
  function readLocal() {
    var raw;
    try { raw = localStorage.getItem(storageKey); }
    catch (error) { throw new Error('Browser storage is unavailable. Enable site storage or sign in to save.'); }
    if (!raw) return [];
    var rows;
    try { rows = JSON.parse(raw); }
    catch (error) { throw new Error('The saved browser Garage could not be read.'); }
    if (!Array.isArray(rows) || rows.length > 20) throw new Error('The saved browser Garage could not be read.');
    var seen = new Set();
    return rows.filter(function (v) {
      if (!v || typeof v.year !== 'string' || typeof v.make !== 'string' || typeof v.model !== 'string') return false;
      if (v.year.length !== 4 || !v.make || v.make.length > 80 || !v.model || v.model.length > 120) return false;
      var identity = key(v);
      if (seen.has(identity)) return false;
      seen.add(identity);
      return true;
    }).map(function (v, index) {
      return { id: 'guest:' + key(v), year: v.year, make: v.make, model: v.model, isDefault: Boolean(v.isDefault) };
    });
  }
  function writeLocal(rows) {
    try { localStorage.setItem(storageKey, JSON.stringify(rows)); }
    catch (error) { throw new Error('Your browser could not save this vehicle. Enable site storage or sign in.'); }
  }
  function notify(removedVehicle) {
    if (removedVehicle) {
      function matches(vehicle) {
        return vehicle &&
          String(vehicle.year) === String(removedVehicle.year) &&
          String(vehicle.make) === String(removedVehicle.make) &&
          String(vehicle.model) === String(removedVehicle.model);
      }

      try {
        var vehicleKey = 'slickmod-mega-explicit-vehicle-v1';
        var vehicleSelection = JSON.parse(
          sessionStorage.getItem(vehicleKey) || 'null'
        );

        if (matches(vehicleSelection)) {
          sessionStorage.removeItem(vehicleKey);
        }

        var categoryKey = 'slickmod-category-ymm-v2';
        var categorySelection = JSON.parse(
          sessionStorage.getItem(categoryKey) || 'null'
        );

        if (matches(categorySelection)) {
          categorySelection.year = '';
          categorySelection.make = '';
          categorySelection.model = '';

          sessionStorage.setItem(
            categoryKey,
            JSON.stringify(categorySelection)
          );
        }
      } catch (error) {
        console.warn('Garage selection could not be cleared.', error);
      }

      window.dispatchEvent(new CustomEvent('sm:garage-removed', {
        detail: {
          year: String(removedVehicle.year),
          make: String(removedVehicle.make),
          model: String(removedVehicle.model)
        }
      }));
    }

    window.dispatchEvent(new CustomEvent('sm:guest-garage-change'));
  }
  async function readResponse(response) {
    var data;
    try { data = await response.json(); }
    catch (error) { throw new Error('Your Garage could not load. Please try again.'); }
    if (!response.ok || data.ok !== true) throw new Error(data.error || 'Your Garage could not be updated.');
    return data;
  }
  async function account() {
    var response = await fetch(endpoint, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (response.status === 401) return null;
    var data = await readResponse(response);

    if (data.guest === true) return null;

    if (!Array.isArray(data.vehicles) || !data.csrfToken) {
      throw new Error('The Garage account session could not be verified.');
    }
    return data;
  }
  function guestResult() {
    return { ok: true, guest: true, csrfToken: '', vehicles: readLocal() };
  }
  async function postAccount(payload, session) {
    return readResponse(await fetch(endpoint, {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({}, payload, { csrfToken: session.csrfToken }))
    }));
  }
  async function merge(session) {
    var pending = readLocal();
    var syncError = '';
    for (var i = 0; i < pending.length; i++) {
      var vehicle = pending[i];
      try {
        var exists = session.vehicles.some(function (v) { return key(v) === key(vehicle); });
        if (!exists) {
          await postAccount({ action: 'add', year: vehicle.year, make: vehicle.make, model: vehicle.model }, session);
          session = await account();
          if (!session) throw new Error('Sign in again to finish syncing your saved vehicles.');
          if (!session.vehicles.some(function (v) { return key(v) === key(vehicle); })) throw new Error('Vehicle sync could not be confirmed.');
        }
        // Read again so a vehicle added in another tab is not removed by an old copy.
        writeLocal(readLocal().filter(function (v) { return key(v) !== key(vehicle); }));
      } catch (error) {
        syncError = error.message;
        break;
      }
    }
    if (!session) throw new Error(syncError || 'Sign in again to finish syncing.');
    return Object.assign({}, session, { guest: false, syncError: syncError });
  }
  async function perform(options) {
    options = options || {};
    if (options.signal && options.signal.aborted) throw new DOMException('Aborted', 'AbortError');
    var session = await account();
    if (session) session = await merge(session);
    if ((options.method || 'GET').toUpperCase() === 'GET') return session || guestResult();
    if ((options.method || '').toUpperCase() !== 'POST') throw new Error('Unsupported Garage request.');
    var payload = JSON.parse(options.body || '{}');
    if (session) {
      var removedVehicle = payload.action === 'remove'
        ? session.vehicles.find(function (vehicle) {
            return vehicle.id === payload.id;
          })
        : null;

      var result = await postAccount(payload, session);
      notify(removedVehicle);
      return result;
    }
    var rows = readLocal();

    var removedGuestVehicle = payload.action === 'remove'
      ? rows.find(function (vehicle) {
          return vehicle.id === payload.id;
        })
      : null;

    if (payload.action === 'add') {
      var vehicle = { year: String(payload.year || '').trim(), make: String(payload.make || '').trim(), model: String(payload.model || '').trim() };
      if (vehicle.year.length !== 4 || !Number.isInteger(Number(vehicle.year)) || Number(vehicle.year) < 1900 || Number(vehicle.year) > new Date().getFullYear() + 2 || !vehicle.make || vehicle.make.length > 80 || !vehicle.model || vehicle.model.length > 120) throw new Error('Choose a valid year, make, and model.');
      var existing = rows.find(function (v) { return key(v) === key(vehicle); });
      if (!existing) {
        if (rows.length >= 20) throw new Error('Your browser Garage can hold up to 20 vehicles.');
        vehicle.id = 'guest:' + key(vehicle);
        vehicle.isDefault = rows.length === 0;
        rows.push(vehicle);
      }
    } else if (payload.action === 'remove' || payload.action === 'setDefault') {
      if (!rows.some(function (v) { return v.id === payload.id; })) throw new Error('Choose a saved vehicle.');
      if (payload.action === 'remove') {
        rows = rows.filter(function (v) { return v.id !== payload.id; });
        if (rows.length && !rows.some(function (v) { return v.isDefault; })) rows[0].isDefault = true;
      } else {
        rows.forEach(function (v) { v.isDefault = v.id === payload.id; });
      }
    } else throw new Error('Unsupported Garage action.');
    writeLocal(rows);
    notify(removedGuestVehicle);
    return guestResult();
  }
  window.SlickModGarage = {
    createMenuBox: function (options) {
      var signal = options.signal;

      function listen(node, event, callback) {
        node.addEventListener(event, callback, { signal: signal });
      }

      function element(tag, text, style) {
        var node = document.createElement(tag);
        if (text) node.textContent = text;
        if (style) node.style.cssText = style;
        return node;
      }

      var box = element('div', '',
        'position:relative;display:grid;' +
        'grid-template-columns:30px minmax(0,1fr) 16px;' +
        'align-items:center;gap:12px;width:100%;min-height:60px;' +
        'padding:9px 14px;box-sizing:border-box;text-align:left;' +
        'border:1px solid #303030;border-radius:5px;' +
        'background:linear-gradient(120deg,#191919,#0e0e0e);' +
        'color:#fff;'
      );

      var icon = document.createElementNS(
        'http://www.w3.org/2000/svg', 'svg'
      );
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('fill', 'none');
      icon.setAttribute('stroke', 'currentColor');
      icon.setAttribute('stroke-width', '2');
      icon.setAttribute('stroke-linecap', 'round');
      icon.setAttribute('stroke-linejoin', 'round');
      icon.setAttribute('aria-hidden', 'true');
      icon.style.cssText =
        'width:28px;height:28px;color:#ffad16;';

      var path = document.createElementNS(
        'http://www.w3.org/2000/svg', 'path'
      );
      path.setAttribute('d',
        'M3 21V8l9-6 9 6v13' +
        'M7 21V10h10v11' +
        'M7 13h10M7 16h10M7 19h10'
      );
      icon.append(path);

      var copy = element('span', '',
        'display:grid;gap:3px;min-width:0;'
      );
      var titleRow = element('span', '',
        'display:flex;align-items:center;gap:5px;'
      );
      var title = element('span', 'My Garage',
        'font-size:16px;font-weight:700;line-height:1.3;' +
        'white-space:nowrap;'
      );
      var divider = element('span', '|',
        'color:#777;font-size:13px;'
      );
      divider.setAttribute('aria-hidden', 'true');

      var manage = element('a', 'Manage',
        'position:relative;z-index:3;pointer-events:auto;' +
        'color:#ddd;text-decoration:none;font-family:inherit;' +
        'font-size:16px;font-weight:700;line-height:1.3;' +
        'white-space:nowrap;'
      );
      manage.href = '/apps/slickmod-garage/page';
      manage.setAttribute('aria-label', 'Manage My Garage');

      titleRow.append(title, divider, manage);

      var subtitle = element('span', 'Choose a saved vehicle',
        'font-size:13px;font-weight:400;line-height:1.35;' +
        'color:#b8b8b8;overflow-wrap:anywhere;'
      );
      copy.append(titleRow, subtitle);

      var arrow = element('span', '',
        'display:block;justify-self:center;align-self:center;' +
        'width:7px;height:7px;box-sizing:border-box;' +
        'border-right:1.5px solid currentColor;' +
        'border-bottom:1.5px solid currentColor;' +
        'transform:rotate(-45deg);'
      );
      arrow.setAttribute('aria-hidden', 'true');

      // Only Manage navigates. The main box always uses the picker.
      var emptyLink = element('span', '', 'display:none;');

      // Saved vehicles: the native dropdown covers the box.
      // Manage sits above it and remains independently clickable.
      var picker = options.savedSelect;
      picker.style.cssText =
        'position:absolute;inset:0;z-index:2;' +
        'width:100%;height:100%;min-height:0;' +
        'margin:0;padding:0;border:0;opacity:0;' +
        'font-size:16px;box-sizing:border-box;cursor:pointer;';

      box.append(icon, copy, arrow, emptyLink, picker);

      function update(text) {
        var hasVehicles = picker.options.length > 1;

        picker.hidden = false;
        picker.disabled = false;
        picker.style.display = 'block';
        picker.style.pointerEvents = 'auto';

        emptyLink.style.display = 'none';

        var generic =
          !text ||
          text === 'Choose or add a vehicle' ||
          text === 'Add your first vehicle';

        var compactLandscape = window.matchMedia(
          '(min-width:750px) and (max-width:1199px)'
        ).matches;

        subtitle.textContent = generic
          ? (hasVehicles
              ? (compactLandscape
                  ? 'Choose vehicle'
                  : 'Choose a saved vehicle')
              : (compactLandscape
                  ? 'Add a vehicle'
                  : 'Add a vehicle to My Garage'))
          : text;

        picker.setAttribute(
          'aria-label',
          'My Garage: ' + subtitle.textContent
        );

        arrow.style.transform =
          'translateY(-2px) rotate(45deg)';
      }

      listen(manage, 'mouseenter', function () {
        if (window.matchMedia(
          '(hover:hover) and (pointer:fine)'
        ).matches) {
          manage.style.color = '#ffad16';
        }
      });

      listen(manage, 'mouseleave', function () {
        manage.style.color = '#ddd';
      });

      [picker, emptyLink, manage].forEach(function (node) {
        listen(node, 'focus', function () {
          box.style.outline = '2px solid #ffad16';
          box.style.outlineOffset = '-2px';
        });
        listen(node, 'blur', function () {
          box.style.outline = '';
          box.style.outlineOffset = '';
        });
      });

      var garageLandscapeQuery = window.matchMedia(
        '(min-width:750px) and (max-width:1199px)'
      );

      listen(garageLandscapeQuery, 'change', function () {
        if (
          subtitle.textContent === 'Choose vehicle' ||
          subtitle.textContent === 'Choose a saved vehicle' ||
          subtitle.textContent === 'Add a vehicle' ||
          subtitle.textContent === 'Add a vehicle to My Garage'
        ) {
          update();
        }
      });

      update();

      return {
        element: box,
        setSubtitle: update
      };
    },
    request: function (options) {
      if (previousGarageRequest) {
        return previousGarageRequest(options);
      }
      var task = queue.then(function () { return perform(options); });
      queue = task.catch(function () {});
      return task.then(function (data) { return Response.json(data); }).catch(function (error) {
        if (error.name === 'AbortError') throw error;
        return Response.json({ ok: false, error: error.message }, { status: 503 });
      });
    }
  };
  window.addEventListener('storage', function (event) {
    if (event.key === storageKey) notify();
  });
})();

(() => {
  'use strict';
  // Desktop and drawer may both request this asset. Initialize each engine once.
  if (window.__slickmodVehicleMenuR40) return;
  window.__slickmodVehicleMenuR40 = true;
  const states = new WeakMap();
  const requests = new Map();
  function getJSON(url) {
    if (!requests.has(url)) {
      requests.set(url, fetch(url, { credentials: 'same-origin' }).then(response => {
        if (!response.ok) throw new Error(`Vehicle data request failed (${response.status})`);
        return response.json();
      }).catch(error => { requests.delete(url); throw error; }));
    }
    return requests.get(url);
  }
  function safeImage(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' ? url.href : null; }
    catch (_) { return null; }
  }
  async function initialize(root) {
    const containers = ['[data-sm-makes]', '[data-sm-models]', '[data-sm-years]', '[data-sm-categories]'].map(selector => root.querySelector(selector));
    const previous = states.get(root);
    const sameContainers = previous && containers.every((node, i) => node === previous.containers[i]);
    if (sameContainers && (previous.pending || previous.failed || (previous.marker && previous.marker.parentNode === containers[0]))) return;
    previous?.controller.abort();
    const state = { containers, pending: true, failed: false, marker: null, controller: new AbortController() };
    states.set(root, state);
    const listen = (element, type, handler, options = {}) => element.addEventListener(type, handler, { ...options, signal: state.controller.signal });
    const find = selector => root.querySelector(selector);
    const makesBox = find('[data-sm-makes]');
    const modelsBox = find('[data-sm-models]');
    const yearsBox = find('[data-sm-years]');
    const categoriesBox = find('[data-sm-categories]');
    const status = find('[data-sm-status]');
    if (![makesBox, modelsBox, yearsBox, categoriesBox, status].every(Boolean)) return;
    let images = {};
    try { images = JSON.parse(find('[data-sm-images]')?.textContent || '{}'); } catch (_) {}
    let vehicles, destinations;
    try {
      [vehicles, destinations] = await Promise.all([getJSON(root.dataset.vehicleData), getJSON(root.dataset.collectionMap)]);
      if (!vehicles || Array.isArray(vehicles) || typeof vehicles !== 'object' || !destinations || typeof destinations !== 'object') throw new Error('Invalid vehicle JSON');
    } catch (error) {
      status.textContent = 'Vehicle data could not load. Reload the page to retry.';
      state.pending = false;
      state.failed = true;
      console.error('SlickMod menu:', error);
      return;
    }
    if (!root.isConnected) { state.controller.abort(); states.delete(root); return; }
    if (states.get(root) !== state || containers.some((node, i) => node !== root.querySelector(['[data-sm-makes]', '[data-sm-models]', '[data-sm-years]', '[data-sm-categories]'][i]))) {
      if (states.get(root) === state) states.delete(root);
      initialize(root);
      return;
    }
    const index = new Map();
    for (const [year, makes] of Object.entries(vehicles)) {
      if (!makes || typeof makes !== 'object') continue;
      for (const [make, models] of Object.entries(makes)) {
        if (!Array.isArray(models)) continue;
        if (!index.has(make)) index.set(make, new Map());
        for (const model of models) {
          if (typeof model !== 'string') continue;
          if (!index.get(make).has(model)) index.get(make).set(model, []);
          index.get(make).get(model).push(year);
        }
      }
    }
    let selectedMake = '', selectedModel = '', selectedYear = '';
    const storageKey = 'slickmod-mega-explicit-vehicle-v1';
    let saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
    function remember() {
      try { sessionStorage.setItem(storageKey, JSON.stringify({ make: selectedMake, model: selectedModel, year: selectedYear })); } catch (_) {}
    }
    const mark = (container, value) => {
      for (const button of container.querySelectorAll('button')) button.setAttribute('aria-pressed', String(button.dataset.value === value));
    };
    function choice(container, value, action, thumbnail) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sm-mega__choice';
      button.dataset.value = value;
      button.setAttribute('aria-pressed', 'false');
      const source = safeImage(thumbnail);
      if (source) {
        const img = document.createElement('img');
        img.className = 'sm-mega__thumb'; img.src = source; img.alt = ''; img.loading = 'lazy'; img.width = 48; img.height = 30;
        img.addEventListener('error', () => img.remove(), { once: true });
        button.append(img);
      }
      const label = document.createElement('span');
      label.className = 'sm-mega__choice-label'; label.textContent = value;
      const arrow = document.createElement('span'); arrow.textContent = '›'; arrow.setAttribute('aria-hidden', 'true');
      button.append(label, arrow);
      listen(button, 'click', action);
      // Selection is click/tap/keyboard only. Hover never changes a vehicle.
      container.append(button);
    }
    function feature() {
      const garageScope = root.closest('[data-sm-guided]') || root;
      const garageBox = garageScope.querySelector(
        '[data-sm-vehicle-garage-trial]'
      );
      garageBox?.updateGarageCard?.();

      find('[data-sm-feature-title]').textContent = [selectedYear, selectedMake, selectedModel].filter(Boolean).join(' ') || 'Choose your vehicle';
      find('[data-sm-feature-description]').textContent = selectedYear ? 'Explore the mapped categories for this vehicle. Confirm product fitment before ordering.' : 'Choose a make, model, and year to browse mapped products.';
      const image = images[`${selectedMake}|${selectedModel}`] || {};
      const hero = find('[data-sm-hero]');
      const source = safeImage(image.hero);
      hero.hidden = !source;
      if (source) { hero.src = source; hero.alt = typeof image.alt === 'string' ? image.alt : `${selectedMake} ${selectedModel}`; }
      else hero.removeAttribute('src');
    }
    listen(find('[data-sm-hero]'), 'error', () => {
      find('[data-sm-hero]').hidden = true;
    });
    function categories() {
      categoriesBox.replaceChildren();
      find('[data-sm-fit]').textContent = selectedYear ? `${selectedYear} ${selectedMake} ${selectedModel}` : 'Choose a year first';
      if (!selectedYear) return;
      // Search across product categories, using the selected vehicle filters.
      const search = new URL(`${window.Shopify?.routes?.root || '/'}search`, location.origin);
      search.searchParams.set('type', 'product');
      search.searchParams.set('q', `${selectedMake} ${selectedModel}`);
      search.searchParams.set('filter.p.m.custom.make', selectedMake);
      search.searchParams.set('filter.p.m.custom.model', selectedModel);
      search.searchParams.set('filter.p.tag', selectedYear);
      const allProducts = document.createElement('a');
      allProducts.className = 'sm-mega__category';
      allProducts.href = search.href;
      allProducts.dataset.smVehicleTile = 'all';

      const allProductsLabel = document.createElement('span');
      allProductsLabel.className = 'sm-vehicle-tile-label';
      allProductsLabel.textContent = 'All Products';

      const allProductsArrow = document.createElement('span');
      allProductsArrow.className = 'sm-vehicle-tile-arrow';
      allProductsArrow.textContent = ' →';
      allProductsArrow.setAttribute('aria-hidden', 'true');

      allProducts.append(allProductsLabel, allProductsArrow);
      allProducts.setAttribute('aria-label', `All products for ${selectedYear} ${selectedMake} ${selectedModel}`);
      categoriesBox.append(allProducts);
      const entry = destinations[[selectedYear, selectedMake, selectedModel].join('|')] || {};
      let count = 0;
      for (const [key, title] of [['tint', 'Tint'], ['wrap', 'Wrap'], ['ppf', 'Paint Protection Film']]) {
        const destination = entry[key];
        if (typeof destination !== 'string' || !destination.trim()) continue;
        let url;
        try { url = new URL(destination, location.origin); } catch (_) { continue; }
        if (url.origin !== location.origin || !url.pathname.startsWith('/collections/')) continue;
        // Keep the same vehicle filter parameters as the original vehicle finder.
        url.searchParams.set('filter.p.m.custom.make', selectedMake);
        url.searchParams.set('filter.p.m.custom.model', selectedModel);
        url.searchParams.set('filter.p.tag', selectedYear);
        url.searchParams.set('q', `${selectedMake} ${selectedModel}`);
        const link = document.createElement('a');
        link.className = 'sm-mega__category';
        link.href = url.href;
        link.dataset.smVehicleTile = key;

        const tileLabel = document.createElement('span');
        tileLabel.className = 'sm-vehicle-tile-label';
        tileLabel.textContent = title;

        const tileArrow = document.createElement('span');
        tileArrow.className = 'sm-vehicle-tile-arrow';
        tileArrow.textContent = ' →';
        tileArrow.setAttribute('aria-hidden', 'true');

        link.append(tileLabel, tileArrow);
        categoriesBox.append(link); count++;
      }
      if (!count) {
        const message = document.createElement('p'); message.className = 'sm-mega__unavailable';
        message.textContent = 'No category destinations are mapped for this vehicle yet. Choose another vehicle or year.';
        categoriesBox.append(message);
      }
      status.textContent = `${selectedYear} ${selectedMake} ${selectedModel} selected. ${count} mapped ${count === 1 ? 'category' : 'categories'} available.`;
    }
    function selectModel(model, deferRender = false) {
      if (selectedModel === model) return;
      selectedModel = model; selectedYear = '';
      mark(modelsBox, model); yearsBox.replaceChildren();
      const years = [...new Set(index.get(selectedMake).get(model))].sort((a,b) => Number(b)-Number(a));
      for (const year of years) choice(yearsBox, year, () => {
        selectedYear = year; mark(yearsBox, year); feature(); categories(); remember();
      });
      if (!deferRender) {
        feature();
        categories();
        status.textContent = `Choose a year for ${selectedMake} ${model}.`;
        remember();
      }
    }
    function selectMake(make, deferRender = false) {
      if (selectedMake === make) return;
      selectedMake = make; selectedModel = ''; selectedYear = '';
      mark(makesBox, make); modelsBox.replaceChildren(); yearsBox.replaceChildren();
      find('[data-sm-model-title]').textContent = `${make} Models`;
      for (const model of [...index.get(make).keys()].sort((a,b) => a.localeCompare(b))) {
        choice(modelsBox, model, () => selectModel(model), images[`${make}|${model}`]?.thumbnail);
      }
      if (!deferRender) {
        feature();
        categories();
        status.textContent = `Choose a ${make} model.`;
        remember();
      }
    }
    makesBox.replaceChildren();
    for (const make of [...index.keys()].sort((a,b) => a.localeCompare(b))) choice(makesBox, make, () => selectMake(make));
    if (!index.size) { status.textContent = 'No vehicles were found in the data. Browse the links below.'; return; }
    modelsBox.replaceChildren();
    yearsBox.replaceChildren();
    categoriesBox.replaceChildren();
    find('[data-sm-model-title]').textContent = 'Models';
    feature();
    status.textContent = 'Please Select';
    // Restore only actual choices made using this revision, never the old default.
    if (saved && index.has(saved.make)) {
      selectMake(saved.make);
      if (index.get(saved.make).has(saved.model)) {
        selectModel(saved.model);
        if (index.get(saved.make).get(saved.model).includes(String(saved.year))) {
          selectedYear = String(saved.year);
          mark(yearsBox, selectedYear); feature(); categories(); remember();
        }
      }
    }
    // Trial: saved Garage vehicles in Shop by Vehicle.
    const garageCleanupScope =
      root.closest('[data-sm-guided]') || root;

    garageCleanupScope.querySelector(
      '[data-sm-vehicle-garage-trial]'
    )?.remove();

    const smVehicleGarageTrial = document.createElement('div');
    smVehicleGarageTrial.dataset.smVehicleGarageTrial = '';
    smVehicleGarageTrial.dataset.smGaragePicker = '';

    const garageHeading = document.createElement('h2');
    garageHeading.style.cssText =
      'display:flex;align-items:center;gap:8px;margin:0;' +
      'font:inherit;font-weight:700;';

    const garageTitle = document.createElement('span');
    garageTitle.textContent = 'My Garage';

    const garageDivider = document.createElement('span');
    garageDivider.textContent = '|';
    garageDivider.setAttribute('aria-hidden', 'true');
    garageDivider.style.opacity = '0.5';

    const garageManage = document.createElement('a');
    garageManage.href = '/apps/slickmod-garage/page';
    garageManage.textContent = 'Manage';
    garageManage.style.cssText =
      'font:inherit;white-space:nowrap;text-decoration:none;';

    garageHeading.append(garageTitle, garageDivider, garageManage);

    function setVehicleGarageHeading(signedIn) {
      garageTitle.style.display = signedIn ? '' : 'none';
      garageDivider.style.display = signedIn ? '' : 'none';
      garageManage.textContent = signedIn ? 'Manage' : 'My Garage';
      garageManage.setAttribute(
        'aria-label',
        signedIn ? 'Manage My Garage' : 'Sign in to My Garage'
      );
    }

    setVehicleGarageHeading(false);

    const garagePicker = document.createElement('select');
    garagePicker.setAttribute('aria-label', 'My Garage saved vehicles');
    garagePicker.add(new Option('Loading saved vehicles…', ''));
    garagePicker.disabled = true;

    const garageFeedback = document.createElement('p');
    garageFeedback.className = 'sm-mega__hint';
    garageFeedback.setAttribute('role', 'status');

    smVehicleGarageTrial.append(
      garageHeading,
      garagePicker,
      garageFeedback
    );

    const garageFeatureCopy = root.closest('header-menu')
      ? find('.sm-mega__feature-copy')
      : null;

    const vehicleGarageMenu = window.SlickModGarage.createMenuBox({
      savedSelect: garagePicker,
      dataUrl: root.dataset.vehicleData,
      signal: state.controller.signal,
      onSaved: function () {
        loadVehicleGarageTrial();
      }
    });

    smVehicleGarageTrial.style.cssText = garageFeatureCopy
      ? 'margin:54px 0 0;padding:0;width:100%;min-width:0;'
      : 'margin:0 0 18px;padding:0;width:100%;min-width:0;';

    smVehicleGarageTrial.replaceChildren(vehicleGarageMenu.element);
    smVehicleGarageTrial.updateGarageCard = function () {
      const addOptionValue = '__sm_add_selected_vehicle__';

      garagePicker.querySelectorAll('option').forEach(function (option) {
        if (option.value === addOptionValue) option.remove();
      });

      const completeVehicle =
        selectedYear && selectedMake && selectedModel;

      const alreadySaved = completeVehicle && garageChoices.some(
        function (vehicle) {
          return (
            String(vehicle.year) === String(selectedYear) &&
            String(vehicle.make) === String(selectedMake) &&
            String(vehicle.model) === String(selectedModel)
          );
        }
      );

      if (completeVehicle && !alreadySaved) {
        const vehicleName = [
          selectedYear,
          selectedMake,
          selectedModel
        ].join(' ');

        garagePicker.add(new Option(
          vehicleName + ' - Add to My Garage',
          addOptionValue
        ));
      }

      if (garagePicker.options[0]) {
        garagePicker.options[0].textContent = garageChoices.length
          ? 'Choose a saved vehicle'
          : completeVehicle && !alreadySaved
            ? 'Choose an option'
            : 'No vehicles added to My Garage';
      }

      const portraitSelection =
        window.matchMedia(
          '(max-width:749px) and (orientation:portrait)'
        ).matches &&
        selectedYear &&
        selectedMake &&
        selectedModel;

      vehicleGarageMenu.setSubtitle(
        portraitSelection
          ? [selectedYear, selectedMake, selectedModel].join(' ')
          : garageChoices.length
            ? 'Choose or add a vehicle'
            : 'Add your first vehicle'
      );
    };

    if (garageFeatureCopy) {
      garageFeatureCopy.append(smVehicleGarageTrial);
    } else {
      makesBox.before(smVehicleGarageTrial);
    }

    let garageChoices = [];
    let garageAddBusy = false;

    listen(window, 'sm:garage-removed', function (event) {
      const removed = event.detail;

      if (
        !removed ||
        String(selectedYear) !== removed.year ||
        String(selectedMake) !== removed.make ||
        String(selectedModel) !== removed.model
      ) return;

      selectedYear = '';
      selectedMake = '';
      selectedModel = '';
      saved = null;

      mark(makesBox, '');
      modelsBox.replaceChildren();
      yearsBox.replaceChildren();
      categoriesBox.replaceChildren();

      find('[data-sm-model-title]').textContent = 'Models';
      garagePicker.value = '';

      feature();
      categories();
      status.textContent = 'Please Select';
      smVehicleGarageTrial.updateGarageCard();

      root.dispatchEvent(new CustomEvent('sm:garage-selected', {
        bubbles: true
      }));
    });

    listen(garagePicker, 'change', async () => {
      if (garagePicker.value === '') return;

      if (garagePicker.value === '__sm_add_selected_vehicle__') {
        garagePicker.value = '';

        if (
          garageAddBusy ||
          !selectedYear ||
          !selectedMake ||
          !selectedModel
        ) return;

        const vehicleToSave = {
          action: 'add',
          year: String(selectedYear),
          make: String(selectedMake),
          model: String(selectedModel)
        };

        garageAddBusy = true;
        vehicleGarageMenu.setSubtitle('Saving your vehicle…');

        try {
          const response = await window.SlickModGarage.request({
            method: 'POST',
            signal: state.controller.signal,
            body: JSON.stringify(vehicleToSave)
          });

          const result = await response.json();

          if (!response.ok || result.ok !== true) {
            throw new Error(
              result.error || 'Your vehicle could not be saved.'
            );
          }

          await loadVehicleGarageTrial();

          if (!state.controller.signal.aborted) {
            const vehicleName = [
              vehicleToSave.year,
              vehicleToSave.make,
              vehicleToSave.model
            ].join(' ');

            vehicleGarageMenu.setSubtitle(
              vehicleName +
              (result.guest
                ? ' · Saved on this device'
                : ' · Saved in My Garage')
            );
          }
        } catch (error) {
          if (error.name !== 'AbortError') {
            vehicleGarageMenu.setSubtitle(error.message);
          }
        } finally {
          garageAddBusy = false;
        }

        return;
      }

      const vehicle = garageChoices[Number(garagePicker.value)];
      if (!vehicle) return;

      const make = String(vehicle.make);
      const model = String(vehicle.model);
      const year = String(vehicle.year);

      // Validate the entire vehicle before changing any selection.
      if (!index.get(make)?.get(model)?.includes(year)) {
        garageFeedback.textContent =
          'This saved vehicle is not available in this menu yet.';
        return;
      }

      selectMake(make, true);
      selectModel(model, true);
      selectedYear = year;
      mark(yearsBox, year);
      feature();
      categories();
      remember();

      garageFeedback.textContent = '';

      // Advance the portrait guided menu to its vehicle summary.
      root.dispatchEvent(new CustomEvent('sm:garage-selected', {
        bubbles: true
      }));

      // Bring each selected choice into view in the header menu.
      if (!root.closest('header-drawer')) {
        requestAnimationFrame(() => {
          if (state.controller.signal.aborted || !root.isConnected) return;

          [makesBox, modelsBox, yearsBox].forEach(list => {
            const selected = list.querySelector(
              'button[aria-pressed="true"]'
            );

            if (!selected || !list.clientHeight) return;

            const listRect = list.getBoundingClientRect();
            const selectedRect = selected.getBoundingClientRect();

            const target =
              list.scrollTop +
              selectedRect.top -
              listRect.top -
              list.clientTop;

            list.scrollTo({
              top: Math.max(0, target),
              behavior: 'instant'
            });
          });
        });
      }
    });

    async function loadVehicleGarageTrial() {
      try {
        const response = await window.SlickModGarage.request({
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
          signal: state.controller.signal
        });

        const result = await response.json();

        if (
          state.controller.signal.aborted ||
          !smVehicleGarageTrial.isConnected
        ) return;

        if (!response.ok || result.ok === false) {
          garagePicker.replaceChildren(
            new Option('Sign in to view saved vehicles', '')
          );
          garagePicker.disabled = true;
          garageFeedback.textContent =
            'Open My Garage to sign in or select vehicle manually.';
          return;
        }

        if (!Array.isArray(result.vehicles)) {
          throw new Error('Garage did not return a vehicle list.');
        }

        setVehicleGarageHeading(Boolean(result.csrfToken));

        garageChoices = result.vehicles.filter(vehicle =>
          vehicle && vehicle.year && vehicle.make && vehicle.model
        );

        garagePicker.replaceChildren(
          new Option(
            garageChoices.length
              ? 'Choose a saved vehicle'
              : 'No vehicles added to My Garage',
            ''
          )
        );

        garageChoices.forEach((vehicle, position) => {
          const label = [
            vehicle.year,
            vehicle.make,
            vehicle.model
          ].join(' ');

          garagePicker.add(new Option(label, String(position)));
        });

        garagePicker.disabled = garageChoices.length === 0;

        if (smVehicleGarageTrial.updateGarageCard) {
          smVehicleGarageTrial.updateGarageCard();
        }

        // Keep the current vehicle selected after reloading Garage.
        const selectedGarageIndex = garageChoices.findIndex(vehicle =>
          String(vehicle.year) === String(selectedYear) &&
          String(vehicle.make) === String(selectedMake) &&
          String(vehicle.model) === String(selectedModel)
        );

        garagePicker.value = selectedGarageIndex >= 0
          ? String(selectedGarageIndex)
          : '';

        garageFeedback.textContent = garageChoices.length
          ? ''
          : 'No saved vehicles yet. Open Manage to add one.';
      } catch (error) {
        if (error.name === 'AbortError') return;

        garagePicker.replaceChildren(
          new Option('Saved vehicles unavailable', '')
        );
        garageFeedback.textContent =
          'Saved vehicles could not load. Refresh to retry.';
      }
    }

    listen(window, 'sm:guest-garage-change', loadVehicleGarageTrial);
    loadVehicleGarageTrial();

    state.marker = makesBox.firstElementChild;
    state.pending = false;
  }
  const selector = '[data-sm-mega][data-vehicle-data]';
  function init(scope = document) {
    if (scope.matches?.(selector)) initialize(scope);
    scope.querySelectorAll(selector).forEach(initialize);
  }
  let frame = 0;
  const pendingScopes = new Set();
  function schedule(scope = document) {
    pendingScopes.add(scope);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const scopes = [...pendingScopes];
      pendingScopes.clear();
      scopes.forEach(scopeToScan => {
        if (scopeToScan === document || scopeToScan.isConnected) init(scopeToScan);
      });
    });
  }
  function start() {
    init();
    // Observe child replacement, not attributes: selection changes cannot trigger loops.
    // Reinitialize only the affected menu/root instead of rescanning the whole document.
    const observer = new MutationObserver(records => {
      const visitedOwners = new Set();
      for (const record of records) {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        // Product grids and app updates in main content cannot replace header menus.
        if (target?.closest?.('main, #MainContent, [role="main"]')) continue;
        const owner = target?.closest?.(selector);
        if (owner) {
          // Results, status text and hero updates do not replace menu controls.
          // Do not scan every product link generated by our own rendering.
          if (target.closest('[data-sm-vehicle-garage-trial], [data-sm-category-options], [data-sm-categories], [data-sm-status], [data-sm-category-status], .sm-mega__feature')) continue;
          if (!visitedOwners.has(owner)) {
            visitedOwners.add(owner);
            schedule(owner);
          }
          continue;
        }
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1 || node.matches('option, img, svg, path, source')) continue;
          if (node.matches?.(selector) || node.querySelector?.(selector)) schedule(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => { observer.disconnect(); if (frame) cancelAnimationFrame(frame); frame = 0; });
    window.addEventListener('pageshow', event => {
      if (event.persisted) { observer.observe(document.body, { childList: true, subtree: true }); schedule(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

/* Category -> YMM -> product types. Universal categories bypass YMM. */
(() => {
  'use strict';
  if (window.__slickmodCategoryMenuR40) return;
  window.__slickmodCategoryMenuR40 = true;
  const states = new WeakMap();
  const cache = new Map();
  const selector = '[data-sm-category-ymm]';
  function json(url) {
    if (!cache.has(url)) {
      const requestController = new AbortController();
      const timeout = setTimeout(() => requestController.abort(), 12000);
      cache.set(url, fetch(url, {credentials:'same-origin', signal:requestController.signal}).then(r => {
        if (!r.ok) throw new Error(`Request failed (${r.status})`);
        return r.json();
      }).catch(e => {cache.delete(url); throw e;}).finally(() => clearTimeout(timeout)));
    }
    return cache.get(url);
  }
  function collectionURL(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try { const u = new URL(value, location.origin); return u.origin === location.origin && /^\/collections\/[^/]+\/?$/.test(u.pathname) ? u : null; } catch (_) { return null; }
  }
  async function productsFor(url) {
    const all = [];
    for (let page = 1; page <= 20; page++) {
      const endpoint = new URL(url.pathname.replace(/\/$/, '') + '/products.json', location.origin);
      endpoint.searchParams.set('limit','250'); endpoint.searchParams.set('page',String(page));
      const data = await json(endpoint.href);
      if (!Array.isArray(data.products)) throw new Error('Invalid product response');
      all.push(...data.products);
      if (data.products.length < 250) return all;
    }
    throw new Error('Collection too large to list completely');
  }
  const labels = {'headlights':'Headlight Tint','tail lights':'Taillight Tint','taillights':'Taillight Tint','side markers':'Sidemarkers','sidemarkers':'Sidemarkers','reflectors':'Reflectors','mirror signals':'Mirror Signals','drl signals':'DRL Signals','headlight sidemarkers':'Headlight Sidemarkers'};
  function init(root) {
    const get = s => root.querySelector(s);
    const choices = get('[data-sm-category-choices]');
    const year = get('[data-sm-category-year]'), make = get('[data-sm-category-make]'), model = get('[data-sm-category-model]');
    if (!choices || !year || !make || !model) return;
    const previous = states.get(root);
    if (previous && previous.choices === choices && previous.year === year && previous.make === make && previous.model === model && previous.first === choices.firstElementChild) {
      previous.repair?.();
      previous.restoreInitial?.();
      return;
    }
    previous?.controller.abort();
    const controller = new AbortController();
    states.set(root,{choices,year,make,model,first:choices.firstElementChild,controller,repair:repairFields});
    const listen = (el,event,fn) => el.addEventListener(event,fn,{signal:controller.signal});
    const options = get('[data-sm-category-options]'), status = get('[data-sm-category-status]');

    // Match Shop by Vehicle's height without growing the Category menu.
    let categoryHeightFrame = 0;
    let categoryHeightObserver = null;

    function syncCategoryMenuHeight() {
      categoryHeightFrame = 0;

      if (controller.signal.aborted || !root.isConnected) return;

      const headerMenu = root.closest('header-menu');
      if (!headerMenu) return;

      const vehicleMenu = headerMenu.querySelector('.sm-mega--vehicle');
      if (!vehicleMenu || vehicleMenu.getBoundingClientRect().height === 0) {
        return;
      }

      const rows = getComputedStyle(vehicleMenu).gridTemplateRows;
      if (!rows || rows === 'none') return;

      if (root.style.gridTemplateRows !== rows) {
        root.style.gridTemplateRows = rows;
      }

      root.style.alignItems = 'stretch';

      root.querySelectorAll(
        ':scope > .sm-mega__category-column'
      ).forEach(function (column) {
        column.style.display = 'flex';
        column.style.flexDirection = 'column';
        column.style.minHeight = '0';
        column.style.overflow = 'hidden';
      });

      const vehiclePanel = get('[data-sm-category-vehicle]');

      if (vehiclePanel) {
        vehiclePanel.style.flex = '1 1 0';
        vehiclePanel.style.minHeight = '0';
        vehiclePanel.style.overflowY = 'auto';
        vehiclePanel.style.overflowX = 'hidden';
        vehiclePanel.style.scrollbarWidth = 'thin';
        vehiclePanel.style.boxSizing = 'border-box';
        vehiclePanel.style.paddingTop = '3px';
        vehiclePanel.style.paddingInlineStart = '3px';
        vehiclePanel.style.paddingInlineEnd = '8px';
        vehiclePanel.style.paddingBottom = '10px';
      }
    }

    function scheduleCategoryMenuHeight() {
      if (categoryHeightFrame || controller.signal.aborted) return;
      categoryHeightFrame = requestAnimationFrame(syncCategoryMenuHeight);
    }

    const categoryHeaderMenu = root.closest('header-menu');
    const referenceVehicleMenu = categoryHeaderMenu?.querySelector(
      '.sm-mega--vehicle'
    );

    if (referenceVehicleMenu && typeof ResizeObserver !== 'undefined') {
      categoryHeightObserver = new ResizeObserver(
        scheduleCategoryMenuHeight
      );
      categoryHeightObserver.observe(referenceVehicleMenu);
    }

    if (categoryHeaderMenu) {
      listen(categoryHeaderMenu, 'pointerenter', scheduleCategoryMenuHeight);
      listen(categoryHeaderMenu, 'pointerdown', scheduleCategoryMenuHeight);
      listen(categoryHeaderMenu, 'focusin', scheduleCategoryMenuHeight);
    }

    listen(window, 'resize', scheduleCategoryMenuHeight);
    listen(window, 'pageshow', scheduleCategoryMenuHeight);

    controller.signal.addEventListener('abort', function () {
      categoryHeightObserver?.disconnect();

      if (categoryHeightFrame) {
        cancelAnimationFrame(categoryHeightFrame);
        categoryHeightFrame = 0;
      }
    }, { once: true });

    scheduleCategoryMenuHeight();
    const hero = get('[data-sm-category-hero]');
    let categoryGraphics = {};
    try { categoryGraphics = JSON.parse(get('[data-sm-category-graphics]')?.textContent || '{}'); } catch (_) {}
    const key = 'slickmod-category-ymm-v2';
    let category = '', vehicles, mappings, dataPromise, sequence = 0;
    let userSelectionRevision = 0;
    const universal = value => ['decals','tools','accessory','apparel'].includes(value);
    function selectionSummary() {
      if (!category) return 'Please Select';
      const button = [...choices.querySelectorAll('button')].find(b => b.dataset.smCategoryChoice === category);
      const title = button?.querySelector('.sm-mega__choice-label')?.textContent.trim() || category;
      if (universal(category)) return `${title} selected · Universal products`;
      const vehicle = [year.value,make.value,model.value].filter(Boolean).join(' ');
      const prompt = !year.value ? 'Choose a year' : !make.value ? 'Choose a make' : !model.value ? 'Choose a model' : '';
      return [
        title,
        root.closest('header-menu') ? '' : vehicle,
        prompt
      ].filter(Boolean).join(' · ');
    }
    function remember() { try {sessionStorage.setItem(key,JSON.stringify({category,year:year.value,make:make.value,model:model.value}));} catch (_) {} }
    function reset(select, text) {select.replaceChildren(new Option(text,'')); select.disabled = true;}
    function image(source, text) {
      // Keep the category illustration through YMM changes and product loading.
      // Product imagery remains the fallback when no dedicated graphic is set.
      const graphic = categoryGraphics?.[category];
      const selectedSource = graphic?.src || source;
      if (!selectedSource) { hero.hidden = true; hero.removeAttribute('src'); return; }
      try {
        const u = new URL(selectedSource,location.origin);
        if (u.protocol !== 'https:') { hero.hidden = true; return; }
        hero.alt = graphic?.src ? graphic.alt || `${category} category graphic` : text || '';
        if (hero.getAttribute('src') !== u.href) hero.src = u.href;
        hero.hidden = false;
      } catch (_) { hero.hidden = true; }
    }
    listen(hero,'error',() => {hero.hidden = true;});
    async function data() {
      if (!dataPromise) dataPromise = json(root.dataset.vehicleData).then(value => {
        vehicles = value;
        if (!vehicles || Array.isArray(vehicles) || typeof vehicles !== 'object') throw new Error('Invalid vehicle data');
        reset(year,'Select year');
        Object.keys(vehicles).sort((a,b) => Number(b)-Number(a)).forEach(v => year.add(new Option(v,v)));
        year.disabled = false;
      }).catch(e => {dataPromise = null; throw e;});
      return dataPromise;
    }
    function repairFields() {
      if (!vehicles || controller.signal.aborted || !root.isConnected) return;
      // Horizon may restore disabled attributes without replacing the select nodes.
      // The old identity-only guard skipped those nodes forever.
      if (year.options.length < 2) {
        const current = year.value;
        const fragment = document.createDocumentFragment();
        fragment.append(new Option('Select year',''));
        Object.keys(vehicles).sort((a,b) => Number(b)-Number(a)).forEach(v => fragment.append(new Option(v,v)));
        year.replaceChildren(fragment);
        year.value = current;
      }
      if (year.disabled) year.disabled = false;
      if (year.value && vehicles[year.value]) {
        if (make.options.length < 2) fillMakes();
        if (make.disabled) make.disabled = false;
      }
      if (year.value && make.value && Array.isArray(vehicles[year.value]?.[make.value])) {
        if (model.options.length < 2) fillModels();
        if (model.disabled && model.options.length > 1) model.disabled = false;
      }
    }
    function fillMakes() {
      reset(make,'Select make');reset(model,'Select model');
      if (vehicles?.[year.value]) {Object.keys(vehicles[year.value]).sort().forEach(v => make.add(new Option(v,v)));make.disabled = false;}
    }
    function fillModels() {
      reset(model,'Select model');
      const values = vehicles?.[year.value]?.[make.value];
      if (Array.isArray(values)) {values.forEach(v => model.add(new Option(v,v)));model.disabled = !values.length;}
    }
    async function showOptions() {
      root.dispatchEvent(new CustomEvent('sm:vehicle-summary-update'));
      const request = ++sequence;
      options.replaceChildren(); image(null); status.textContent = selectionSummary();
      if (!category || universal(category)) return;
      if (!(year.value && make.value && model.value)) return;
      const selected = {category,year:year.value,make:make.value,model:model.value};
      if (!mappings) {
        status.textContent = `${selectionSummary()} · Loading collection destinations…`;
        try {
          const value = await json(root.dataset.collectionMap);
          if (!value || Array.isArray(value) || typeof value !== 'object') throw new Error('Invalid collection map');
          mappings = value;
        } catch (_) {
          if (request === sequence && !controller.signal.aborted) status.textContent = `${selectionSummary()} · Collection destinations could not load. Select the category again to retry.`;
          return;
        }
      }
      if (request !== sequence || controller.signal.aborted || !root.isConnected) return;
      const entry = mappings?.[[selected.year,selected.make,selected.model].join('|')] || {};
      const mapKey = selected.category === 'wraps' ? 'wrap' : selected.category;
      const destination = collectionURL(entry[mapKey]);
      if (!destination) {status.textContent = `No ${selected.category} collection is mapped for this vehicle yet.`;return;}
      status.textContent = `${selectionSummary()} · Loading matching options…`;
      try {
        const products = await productsFor(destination);
        if (request !== sequence || !root.isConnected || controller.signal.aborted) return;
        const matching = products.filter(p => {
          const tags = Array.isArray(p.tags) ? p.tags.map(String) : String(p.tags || '').split(',').map(t => t.trim());
          return tags.includes(selected.year);
        });
        if (!matching.length) {status.textContent = `${selectionSummary()} · No products with a matching year tag were found.`;return;}
        const groups = new Map();
        for (const product of matching) {
          const type = String(product.product_type || 'Other options').trim() || 'Other options';
          if (!groups.has(type)) groups.set(type,[]);
          groups.get(type).push(product);
        }
        const fragment = document.createDocumentFragment();
        if (matching.length > 1) {
          const viewAllURL = new URL(destination.href);
          viewAllURL.searchParams.set('filter.p.tag', selected.year);
          viewAllURL.searchParams.set('filter.p.m.custom.make', selected.make);
          viewAllURL.searchParams.set('filter.p.m.custom.model', selected.model);
          const viewAll = document.createElement('a');
          viewAll.className = 'sm-mega__category';
          viewAll.href = viewAllURL.href;
          viewAll.textContent = 'View All →';
          viewAll.setAttribute('aria-label', `View all ${selected.category} products for ${selected.year} ${selected.make} ${selected.model}`);
          fragment.append(viewAll);
        }
        for (const [type, products] of [...groups.entries()].sort((a,b) => a[0].localeCompare(b[0]))) {
          const group = document.createElement('details');group.className = 'sm-mega__product-group sm-mega__option-disclosure';
          const heading = document.createElement('summary');heading.className = 'sm-mega__option-summary';
          const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
          svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('aria-hidden','true');svg.setAttribute('fill','none');svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','1.4');
          const path = document.createElementNS('http://www.w3.org/2000/svg','path');
          const lowerType = type.toLowerCase();
          path.setAttribute('d', /head|tail|light|signal|marker/.test(lowerType) ? 'M4 7h6a5 5 0 0 1 0 10H4V7Zm10 1 6-2m-5 6h6m-7 4 6 2M7 8v8' : /wrap|window|chrome/.test(lowerType) ? 'M4 5h16v14H4V5Zm3 3h10v8H7V8Zm5-3v14' : 'M12 3 21 12 12 21 3 12 12 3Zm0 5 4 4-4 4-4-4 4-4Z');
          svg.append(path);
          const label = document.createElement('span');label.textContent = selected.category === 'tint' ? labels[type.toLowerCase()] || type : type;
          const arrow = document.createElement('span');arrow.className = 'sm-mega__option-arrow';arrow.textContent = '›';arrow.setAttribute('aria-hidden','true');
          heading.append(svg,label,arrow);group.append(heading);
          for (const product of products) {
            if (typeof product.handle !== 'string' || !product.handle) continue;
            const link = document.createElement('a');link.className = 'sm-mega__category-detail';
            link.href = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(product.handle)}`;
            link.textContent = product.title;group.append(link);
          }
          fragment.append(group);
        }
        options.replaceChildren(fragment);
        image(matching[0]?.images?.[0]?.src, `${selected.make} ${selected.model}`);
        get('[data-sm-category-title]').textContent = `${selected.year} ${selected.make} ${selected.model}`;
        const productLabel = matching.length === 1 ? 'product' : 'products';
        status.textContent = `${selectionSummary()} · ${matching.length} matching ${productLabel}.`;
        get('[data-sm-category-hint]').textContent = `Matching ${productLabel} available`;
      } catch (error) {
        if (request !== sequence || controller.signal.aborted) return;
        status.textContent = `${selectionSummary()} · Options could not load. Open the vehicle collection below.`;
        const link = document.createElement('a');link.className = 'sm-mega__category';
        destination.searchParams.set('filter.p.tag',selected.year);
        destination.searchParams.set('filter.p.m.custom.make',selected.make);
        destination.searchParams.set('filter.p.m.custom.model',selected.model);
        link.href = destination.href;link.textContent = 'Browse vehicle collection →';options.replaceChildren(link);
        console.error('SlickMod category options:',error);
      }
    }
    async function choose(button, restoring = false) {
      if (!restoring) userSelectionRevision++;
      ++sequence;
      category = button.dataset.smCategoryChoice;
      const title = button.querySelector('.sm-mega__choice-label').textContent;
      choices.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
      get('[data-sm-category-heading]').textContent = `${title} options`;
      get('[data-sm-category-title]').textContent = title;
      get('[data-sm-category-vehicle]').hidden = universal(category);
      get('[data-sm-category-vehicle-column]').hidden = universal(category);
      root.classList.toggle('sm-mega--universal',universal(category));
      get('[data-sm-category-hint]').textContent = universal(category) ? 'Universal products. No vehicle needed.' : 'Matching products available';
      get('[data-sm-category-description]').textContent = universal(category) ? 'Browse universal products for your next upgrade.' : 'Choose your vehicle to view the options mapped to it.';
      options.replaceChildren();status.textContent = selectionSummary();image(null);
      root.dispatchEvent(new CustomEvent('sm:vehicle-summary-update'));
      // Restoring a menu must never overwrite another menu's saved selection.
      if (!restoring) remember();
      if (universal(category)) {
        const template = root.querySelector(`template[data-sm-universal="${category}"]`);
        if (template) {options.append(template.content.cloneNode(true));image(options.querySelector('[data-sm-universal-image]')?.dataset.smUniversalImage,title);}
        else status.textContent = 'This universal collection is not connected yet.';
        return;
      }
      const selectedCategory = category;
      try {await data();if (!restoring && category === selectedCategory) showOptions();}
      catch (_) {if (category === selectedCategory) status.textContent = 'Vehicle data could not load. Select the category again to retry.';}
    }
    choices.querySelectorAll('button').forEach(button => listen(button,'click',() => choose(button)));
    listen(year,'change',() => {userSelectionRevision++;fillMakes();remember();showOptions();});
    listen(make,'change',() => {userSelectionRevision++;fillModels();remember();showOptions();});
    listen(model,'change',() => {userSelectionRevision++;remember();showOptions();});

    // Connect My Garage to this menu's existing YMM controls.
    const garagePanel = get('[data-sm-category-vehicle]');

    if (garagePanel) {
      garagePanel.querySelector('[data-sm-garage-picker]')?.remove();

      root.querySelector('[data-sm-garage-footer]')?.remove();

      const garageBox = document.createElement('div');
      garageBox.dataset.smGaragePicker = '';

      const garageLabel = document.createElement('label');
      garageLabel.append(document.createTextNode('My Garage'));

      const garageSelect = document.createElement('select');
      garageSelect.add(new Option('Loading saved vehicles…', ''));
      garageSelect.disabled = true;
      garageLabel.append(garageSelect);

      const garageMessage = document.createElement('p');
      garageMessage.className = 'sm-mega__hint';
      garageMessage.setAttribute('role', 'status');

      const garageLink = document.createElement('a');
      garageLink.href = '/apps/slickmod-garage/page';
      garageLink.textContent = 'Manage My Garage';

      const garageSave = document.createElement('button');
      garageSave.type = 'button';
      garageSave.textContent = 'Add to My Garage';
      garageSave.hidden = true;

      // Keep Reset and Garage actions together.
      const resetVehicle = garagePanel.querySelector(
        '.sm-mega__reset-vehicle'
      );

      garageSave.classList.add('sm-mega__reset-vehicle');
      garageSave.setAttribute('data-sm-garage-save', '');

      if (resetVehicle) {
        let actionRow = garagePanel.querySelector(
          '[data-sm-vehicle-actions]'
        );

        if (!actionRow) {
          actionRow = document.createElement('div');
          actionRow.setAttribute('data-sm-vehicle-actions', '');
          resetVehicle.before(actionRow);
        }

        actionRow.append(resetVehicle, garageSave);
      } else {
        garagePanel.append(garageSave);
      }

      let garageBusy = false;
      let garageAccountReady = false;

      function selectedGarageVehicle() {
        if (!year.value || !make.value || !model.value) return null;
        return {
          year: year.value,
          make: make.value,
          model: model.value
        };
      }

      function vehicleKey(vehicle) {
        return [
          String(vehicle.year),
          String(vehicle.make),
          String(vehicle.model)
        ].join('|');
      }

      function updateGarageSave() {
        const selected = selectedGarageVehicle();
        garageSave.hidden = !selected;
        if (!selected) return;

        const alreadySaved = garageVehicles.some(function (vehicle) {
          return vehicleKey(vehicle) === vehicleKey(selected);
        });

        garageSave.disabled = garageBusy || alreadySaved;

        garageSave.textContent = garageBusy
          ? 'Saving…'
          : alreadySaved
            ? (garageAccountReady
                ? 'Saved in My Garage'
                : 'Saved on this device')
            : 'Add to My Garage';
      }

      listen(year, 'change', updateGarageSave);
      listen(make, 'change', updateGarageSave);
      listen(model, 'change', updateGarageSave);

      listen(garageSave, 'click', async function () {
        const selected = selectedGarageVehicle();
        if (!selected || garageBusy) return;

        garageBusy = true;
        updateGarageSave();
        garageMessage.textContent = 'Saving your vehicle…';

        try {
          // Obtain a fresh token, as the existing Garage page does.
          const sessionResponse = await window.SlickModGarage.request({
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            signal: controller.signal
          });

          const session = await sessionResponse.json();

          if (
            !sessionResponse.ok ||
            session.ok === false ||
            (!session.guest && !session.csrfToken) ||
            !Array.isArray(session.vehicles)
          ) {
            garageAccountReady = false;
            throw new Error('Open My Garage to sign in, then try again.');
          }

          // Check the current account list before adding.
          const exists = session.vehicles.some(function (vehicle) {
            return vehicleKey(vehicle) === vehicleKey(selected);
          });

          if (!exists) {
            const saveResponse = await window.SlickModGarage.request({
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              signal: controller.signal,
              body: JSON.stringify({
                action: 'add',
                year: selected.year,
                make: selected.make,
                model: selected.model,
                csrfToken: session.csrfToken
              })
            });

            const saved = await saveResponse.json();

            if (!saveResponse.ok || saved.ok === false) {
              throw new Error(saved.error || 'Your vehicle could not be saved.');
            }
          }

          garageLoaded = false;
          await loadGarage();

          if (!controller.signal.aborted) {
            garageMessage.textContent = garageAccountReady
              ? (exists
                  ? 'This vehicle is already in My Garage.'
                  : 'Your vehicle was saved to My Garage.')
              : 'Vehicle saved on this device. Sign in to sync it to your account.';
          }
        } catch (error) {
          if (error.name !== 'AbortError') {
            garageMessage.textContent = error.message;
          }
        } finally {
          garageBusy = false;
          if (!controller.signal.aborted) updateGarageSave();
        }
      });

      // Garage heading and Manage link on one line.
        const categoryGarageMenu = window.SlickModGarage.createMenuBox({
        savedSelect: garageSelect,
        dataUrl: root.dataset.vehicleData,
        signal: controller.signal,
        onSaved: function () {
          garageLoaded = false;
          loadGarage();
        }
      });

      garageBox.style.cssText =
        'display:block;width:100%;min-width:0;margin:0 0 16px;';

      // Balanced desktop Category vehicle-column spacing.
      if (root.closest('header-menu')) {
        garageBox.style.marginBottom = '6px';

        categoryGarageMenu.element.style.minHeight = '46px';
        categoryGarageMenu.element.style.padding = '3px 10px';

        const ymmFields = garagePanel.querySelector(
          '.sm-mega__ymm-fields'
        );

        if (ymmFields) {
          ymmFields.style.gap = '7px';
          ymmFields.style.marginBottom = '5px';

          ymmFields.querySelectorAll('label').forEach(function (label) {
            label.style.gap = '4px';
          });

          ymmFields.querySelectorAll('select').forEach(function (select) {
            select.style.minHeight = '32px';
            select.style.height = '32px';
            select.style.padding = '4px 6px';
            select.style.fontSize = '14px';
          });
        }

        const vehicleActions = garagePanel.querySelector(
          '[data-sm-vehicle-actions]'
        );

        if (vehicleActions) {
          vehicleActions.style.marginTop = '16px';
          vehicleActions.style.gap = '6px';

          vehicleActions.querySelectorAll('button').forEach(function (button) {
            button.style.minHeight = '32px';
            button.style.fontSize = '12px';
            button.style.lineHeight = '1.25';
            button.style.setProperty(
              'padding',
              '4px 6px',
              'important'
            );
          });
        }
      }
      garageBox.replaceChildren(categoryGarageMenu.element);
      garagePanel.prepend(garageBox);

      function setCategoryGarageHeading(signedIn) {
        garageBox.dataset.smGarageSignedIn = String(signedIn);
      }

      function updateCategoryGarageCard() {
        const addValue = '__sm_add_category_vehicle__';

        garageSelect.querySelectorAll('option').forEach(option => {
          if (option.value === addValue) option.remove();
        });

        const selected = selectedGarageVehicle();
        const eligible = category && !universal(category) && selected;

        const savedIndex = selected
          ? garageVehicles.findIndex(vehicle =>
              vehicleKey(vehicle) === vehicleKey(selected)
            )
          : -1;

        if (eligible && savedIndex === -1) {
          const vehicleName = [
            selected.year,
            selected.make,
            selected.model
          ].join(' ');

          const addOption = new Option(
            vehicleName + ' - Add to My Garage',
            addValue
          );

          addOption.disabled = garageBusy;
          garageSelect.add(addOption);
        }

        garageSelect.disabled =
          garageVehicles.length === 0 &&
          !(eligible && savedIndex === -1);

        // Highlight the current saved vehicle when reopening.
        garageSelect.value = savedIndex >= 0
          ? String(savedIndex)
          : '';

        const portraitSelection =
          window.matchMedia(
            '(max-width:749px) and (orientation:portrait)'
          ).matches &&
          eligible;

        categoryGarageMenu.setSubtitle(
          portraitSelection
            ? [year.value, make.value, model.value].join(' ')
            : garageVehicles.length
              ? 'Choose or add a vehicle'
              : 'Add your first vehicle'
        );
      }

      const useGarageFooter =
        garagePanel.closest('[data-sm-category-vehicle-column]') &&
        garagePanel.closest('header-menu');

      if (useGarageFooter) {
        garageMessage.setAttribute('data-sm-garage-footer', '');
        root.append(garageMessage);
      } else {
        garagePanel.append(garageMessage);
      }

      let garageVehicles = [];
      let garageLoading = false;
      let garageLoaded = false;

      async function loadGarage() {
        if (
          garageLoading ||
          garageLoaded ||
          controller.signal.aborted
        ) return;

        garageLoading = true;
        garageMessage.textContent = 'Loading saved vehicles…';

        try {
          const response = await window.SlickModGarage.request({
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            signal: controller.signal
          });

          const result = await response.json();

          if (controller.signal.aborted || !root.isConnected) return;

          if (!response.ok || result.ok === false) {
            garageSelect.replaceChildren(
              new Option('Sign in to view saved vehicles', '')
            );
            garageSelect.disabled = true;
            updateGarageSelectionMessage();
            updateGarageSave();
            return;
          }

          if (!Array.isArray(result.vehicles)) {
            throw new Error('Garage did not return a vehicle list.');
          }

          garageAccountReady = Boolean(result.csrfToken);
          setCategoryGarageHeading(garageAccountReady);

          garageVehicles = result.vehicles.filter(function (vehicle) {
            return vehicle && vehicle.year && vehicle.make && vehicle.model;
          });

          garageSelect.replaceChildren(
            new Option(
              garageVehicles.length
                ? 'Choose a saved vehicle'
                : 'No vehicles added to My Garage',
              ''
            )
          );

          garageVehicles.forEach(function (vehicle, index) {
            const label = [
              vehicle.year,
              vehicle.make,
              vehicle.model
            ].join(' ');

            garageSelect.add(new Option(label, String(index)));
          });

          garageSelect.disabled = garageVehicles.length === 0;
          updateCategoryGarageCard();
          garageLoaded = true;
          updateGarageSelectionMessage();
          updateGarageSave();
        } catch (error) {
          if (error.name !== 'AbortError') {
            if (selectedGarageVehicle()) {
              updateGarageSelectionMessage();
            } else {
              garageMessage.textContent =
                'Saved vehicles could not load. Reopen the menu to retry.';
            }
          }
        } finally {
          garageLoading = false;
        }
      }

      listen(garageSelect, 'change', async function () {
        if (garageSelect.value === '__sm_add_category_vehicle__') {
          garageSelect.value = '';

          if (!garageBusy) {
            updateGarageSave();

            if (!garageSave.disabled) {
              garageSave.click();
            }
          }

          return;
        }

        // Also invalidates any pending restoration of an older vehicle.
        const revision = ++userSelectionRevision;

        if (garageSelect.value === '') return;

        const vehicle = garageVehicles[Number(garageSelect.value)];
        if (!vehicle) return;

        const selectedCategory = category;
        garageMessage.textContent = 'Selecting vehicle…';

        try {
          await data();

          if (
            controller.signal.aborted ||
            !root.isConnected ||
            revision !== userSelectionRevision ||
            category !== selectedCategory
          ) return;

          const selectedYear = String(vehicle.year);
          const selectedMake = String(vehicle.make);
          const selectedModel = String(vehicle.model);

          const availableModels =
            vehicles?.[selectedYear]?.[selectedMake];

          if (
            !Array.isArray(availableModels) ||
            !availableModels.includes(selectedModel)
          ) {
            garageMessage.textContent =
              'This vehicle is not in the menu’s vehicle list. ' +
              'Choose another vehicle or select manually.';
            return;
          }

          year.value = selectedYear;
          fillMakes();
          make.value = selectedMake;
          fillModels();
          model.value = selectedModel;

          remember();
          showOptions();

          updateGarageSelectionMessage();
          updateGarageSave();

          // Tell the portrait menu that a complete vehicle was chosen.
          root.dispatchEvent(new CustomEvent('sm:garage-selected', {
            bubbles: true
          }));

          // Tell the portrait menu that a complete vehicle was chosen.
          root.dispatchEvent(new CustomEvent('sm:garage-selected', {
            bubbles: true
          }));
        } catch (error) {
          if (revision === userSelectionRevision) {
            garageMessage.textContent =
              'The vehicle could not be selected. Please try again.';
          }
        }
      });

      listen(window, 'resize', updateGarageSelectionMessage);

      function updateGarageSelectionMessage() {
        updateCategoryGarageCard();

        if (!category || universal(category)) {
          garageMessage.textContent = '';
          return;
        }

        if (year.disabled || year.options.length < 2) {
          garageMessage.textContent = '';
          return;
        }

        if (year.value && make.value && model.value) {
          const mobilePortrait = window.matchMedia(
            '(max-width: 749px) and (orientation: portrait)'
          ).matches;

          garageMessage.textContent = mobilePortrait
            ? ''
            : [year.value, make.value, model.value].join(' ') +
              ' selected.';
          return;
        }

        if (year.value && make.value) {
          garageMessage.textContent = window.matchMedia(
            '(max-width: 749px) and (orientation: portrait)'
          ).matches
            ? ''
            : [year.value, make.value].join(' ') +
              ' · Choose a model.';
          return;
        }

        if (year.value) {
          garageMessage.textContent = window.matchMedia(
            '(max-width: 749px) and (orientation: portrait)'
          ).matches
            ? ''
            : year.value + ' · Choose a make.';
          return;
        }

        garageMessage.textContent = window.matchMedia(
          '(max-width: 749px) and (orientation: portrait)'
        ).matches
          ? ''
          : 'Choose a year to find your vehicle.';
      }

      listen(root, 'sm:vehicle-summary-update', function () {
        if (garageBusy) return;
        updateGarageSelectionMessage();
        updateGarageSave();
      });

      function clearGarageChoice() {
        garageSelect.value = '';

        if (!garageBusy) {
          updateGarageSelectionMessage();
        }
      }

      listen(year, 'change', clearGarageChoice);
      listen(make, 'change', clearGarageChoice);
      listen(model, 'change', clearGarageChoice);

      listen(window, 'sm:garage-removed', function (event) {
        const removed = event.detail;
        const selected = selectedGarageVehicle();

        if (
          !removed ||
          !selected ||
          vehicleKey(selected) !== vehicleKey(removed)
        ) return;

        userSelectionRevision++;
        sequence++;

        year.value = '';
        fillMakes();
        garageSelect.value = '';

        remember();
        showOptions();
        updateGarageSelectionMessage();
        updateGarageSave();

        root.dispatchEvent(new CustomEvent('sm:garage-selected', {
          bubbles: true
        }));
      });

      listen(window, 'sm:guest-garage-change', function () {
        if (garageBusy) return;
        garageLoaded = false;
        loadGarage();
      });

      // Check Garage once when this picker initializes.
      // Clicking or focusing the menu must not restart the request.
      loadGarage();
    }
    // Recheck the controls whenever the menu is entered, including disabled fields.
    listen(root,'pointerenter',() => {
      if (vehicles) repairFields();
      else data().then(repairFields).catch(() => {
        if (category && !universal(category)) status.textContent = `${selectionSummary()} · Vehicle data could not load. Reopen the menu to retry.`;
      });
    });
    listen(root,'focusin',repairFields);
    // Warm only the small vehicle list; retry a transient first-request failure once.
    data().catch(() => {
      setTimeout(() => {
        if (!controller.signal.aborted && root.isConnected) data().then(repairFields).catch(() => {});
      },1000);
    });
    status.textContent = 'Please Select';
    // Restore only at initialization/open, never from focusin or repairFields.
    let restorationPending = false;
    let restorationFrame = 0;

    function readSavedSelection() {
      try { return JSON.parse(sessionStorage.getItem(key) || 'null'); }
      catch (_) { return null; }
    }

    function stillCurrent(revision) {
      return !controller.signal.aborted && root.isConnected &&
        userSelectionRevision === revision &&
        get('[data-sm-category-year]') === year &&
        get('[data-sm-category-make]') === make &&
        get('[data-sm-category-model]') === model;
    }

    function viewMatchesSaved(saved, button) {
      if (!saved || category !== saved.category || !button) return false;
      const title = button.querySelector('.sm-mega__choice-label')?.textContent;
      const isUniversal = universal(saved.category);
      const panel = get('[data-sm-category-vehicle]');
      const column = get('[data-sm-category-vehicle-column]');
      if (button.getAttribute('aria-pressed') !== 'true' ||
          get('[data-sm-category-heading]')?.textContent !== `${title} options` ||
          !panel || !column || panel.hidden !== isUniversal || column.hidden !== isUniversal ||
          root.classList.contains('sm-mega--universal') !== isUniversal) return false;
      if (isUniversal) return options.childElementCount > 0;
      if (year.value !== String(saved.year || '') ||
          make.value !== String(saved.make || '') ||
          model.value !== String(saved.model || '') || year.disabled ||
          (year.value && make.disabled) || (make.value && model.disabled)) return false;
      // A complete vehicle must also retain its rendered results. An incomplete
      // choice correctly has no results yet and needs no rebuild on reopen.
      return !(year.value && make.value && model.value) || options.childElementCount > 0;
    }

    async function restoreSavedSelection(revision) {
      if (restorationPending || !stillCurrent(revision)) return;
      const saved = readSavedSelection();
      const button = [...choices.querySelectorAll('button')]
        .find(b => b.dataset.smCategoryChoice === saved?.category);
      if (!button || viewMatchesSaved(saved, button)) return;
      restorationPending = true;
      try {
        if (!universal(saved.category)) {
          // Finish the initial data load before assigning any selected values.
          await data();
          if (!stillCurrent(revision)) return;
          reset(year,'Select year');
          Object.keys(vehicles).sort((a,b) => Number(b)-Number(a))
            .forEach(v => year.add(new Option(v,v)));
          year.disabled = false;
          reset(make,'Select make');
          reset(model,'Select model');
          const savedYear = String(saved.year || '');
          const savedMake = String(saved.make || '');
          const savedModel = String(saved.model || '');
          if (Object.prototype.hasOwnProperty.call(vehicles,savedYear)) {
            year.value = savedYear;
            fillMakes();
            if (Object.prototype.hasOwnProperty.call(vehicles[savedYear],savedMake)) {
              make.value = savedMake;
              fillModels();
              const models = vehicles[savedYear][savedMake];
              if (Array.isArray(models) && models.includes(savedModel)) model.value = savedModel;
            }
          }
        }
        if (!stillCurrent(revision)) return;
        // Repaint category highlight, headings and visibility as well as YMM.
        // choose(..., true) does not write storage or start an early product request.
        await choose(button,true);
        if (!stillCurrent(revision) || category !== saved.category) return;
        if (!universal(category)) await showOptions();
      } catch (error) {
        if (stillCurrent(revision)) console.warn('SlickMod saved category restoration:',error);
      } finally {
        restorationPending = false;
      }
    }

    function queueSavedRestoration() {
      if (restorationPending || restorationFrame || controller.signal.aborted) return;
      const revision = userSelectionRevision;
      restorationFrame = requestAnimationFrame(() => {
        restorationFrame = 0;
        if (stillCurrent(revision)) restoreSavedSelection(revision);
      });
    }

    // Recover an initial hydration reset, but never replay saved choices during
    // a user's active selection sequence. Reopening is handled separately below.
    function restoreInitialViewIfReset() {
      if (userSelectionRevision || restorationPending || !vehicles) return;

      const saved = readSavedSelection();
      const button = [...choices.querySelectorAll('button')]
        .find(b => b.dataset.smCategoryChoice === saved?.category);

      if (!button) return;

      const title = button.querySelector(
        '.sm-mega__choice-label'
      )?.textContent;

      const panel = get('[data-sm-category-vehicle]');

      const guidedDrawer = root.closest(
        'header-drawer [data-sm-guided]'
      );

      const guidedControlsVisibility =
        guidedDrawer?.dataset.smGuidedReady === 'true';

      const selectionWasReset =
        button.getAttribute('aria-pressed') !== 'true' ||
        get('[data-sm-category-heading]')?.textContent !==
          `${title} options`;

      const panelUnexpectedlyHidden =
        !guidedControlsVisibility &&
        !universal(saved.category) &&
        panel?.hidden;

      if (selectionWasReset || panelUnexpectedlyHidden) {
        queueSavedRestoration();
      }
    }
    states.get(root).restoreInitial = restoreInitialViewIfReset;

    const menuRow = root.closest('.menu-list__list-item');
    const trigger = menuRow?.querySelector(':scope > [ref="menuitem"]');
    const drawerDetails = trigger ? null : root.closest('details');
    const openTarget = trigger || drawerDetails;
    let openObserver;
    let wasOpen = trigger ? trigger.getAttribute('aria-expanded') === 'true' : !!drawerDetails?.open;
    if (openTarget) {
      openObserver = new MutationObserver(() => {
        const isOpen = trigger ? trigger.getAttribute('aria-expanded') === 'true' : drawerDetails.open;
        if (isOpen && !wasOpen) queueSavedRestoration();
        wasOpen = isOpen;
      });
      openObserver.observe(openTarget,{attributes:true,attributeFilter:[trigger ? 'aria-expanded' : 'open']});
    }
    controller.signal.addEventListener('abort',() => {
      openObserver?.disconnect();
      if (restorationFrame) cancelAnimationFrame(restorationFrame);
      restorationFrame = 0;
    },{once:true});
    queueSavedRestoration();
  }
  function scan(scope = document) {
    if (scope.matches?.(selector)) init(scope);
    scope.querySelectorAll?.(selector).forEach(init);
  }
  let frame = 0;
  const pendingScopes = new Set();
  function schedule(scope = document) {
    pendingScopes.add(scope);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const scopes = [...pendingScopes];
      pendingScopes.clear();
      scopes.forEach(scopeToScan => {
        if (scopeToScan === document || scopeToScan.isConnected) scan(scopeToScan);
      });
    });
  }
  function start() {
    scan();
    const observer = new MutationObserver(records => {
      const visitedOwners = new Set();
      for (const record of records) {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        // Product grids and app updates in main content cannot replace header menus.
        if (target?.closest?.('main, #MainContent, [role="main"]')) continue;
        const owner = target?.closest?.(selector);
        if (owner) {
          // Results, status text and hero updates do not replace menu controls.
          // Do not scan every product link generated by our own rendering.
          if (target.closest('[data-sm-category-options], [data-sm-categories], [data-sm-status], [data-sm-category-status], .sm-mega__feature')) continue;
          if (!visitedOwners.has(owner)) {
            visitedOwners.add(owner);
            schedule(owner);
          }
          continue;
        }
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1 || node.matches('option, img, svg, path, source')) continue;
          if (node.matches?.(selector) || node.querySelector?.(selector)) schedule(node);
        }
      }
    });
    observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
    window.addEventListener('pagehide',() => {observer.disconnect();if(frame)cancelAnimationFrame(frame);frame=0;});
    window.addEventListener('pageshow',e => {if(e.persisted){observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});schedule();}});
  }
  if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',event => scan(event.target));
})();
